"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdColorPicker = _interopRequireDefault(require("cccisd-color-picker"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Component = function Component(props) {
  var field = props.field;
  return /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: field.value,
    onChange: field.onChange
  });
};
Component.propTypes = {
  field: _propTypes["default"].object
};
var _default = exports["default"] = Component;